// ── Context payload reader ────────────────────────────────────────────────────
window.contactContext = {
  payload: null,
  style: (() => {
    try { return localStorage.getItem('ci-contact-ctx-style') || 'pill'; } catch (e) { return 'pill'; }
  })(),

  ACC_LABELS: {
    'boards-perimeter': 'Boards Perimeter', 'markings-game': 'Game Lines',
    'boards': 'Board Branding', 'netting': 'Protective Netting',
    'lighting': 'Lighting', 'matting': 'Rubber Matting',
    'bench': 'Player Bench', 'nets': 'Goalie Nets', 'seal': 'Seal Skate Aids'
  },

  read() {
    let raw;
    try { raw = sessionStorage.getItem('ci_contact_ctx'); } catch(e) {}
    if (!raw) return null;
    try { sessionStorage.removeItem('ci_contact_ctx'); } catch(e) {}
    let d;
    try { d = JSON.parse(raw); } catch(e) { return null; }
    const ref = d.ref;

    if (ref === 'used-equipment') {
      const pkg = d.pkg;
      const PACKAGES = {
        '01': { size: "20' x 30'", chiller: '4 Ton', kind: 'Refrigeration Package' },
        '02': { size: "24' x 50'", chiller: '7 Ton', kind: 'Refrigeration Package' },
        '03': { size: "24' x 60'", chiller: '10 Ton', kind: 'Refrigeration Package' },
        '04': { size: "30' x 60'", chiller: '10 Ton', kind: 'Refrigeration Package' },
        '05': { size: "40' x 80'", chiller: '2 x 10 Ton', kind: 'Refrigeration Package' },
        '06': { size: "35' x 120'", chiller: '60 Ton', kind: 'Training Rink' },
        '07': { size: "20' x 30'", chiller: '4 Ton', kind: 'Refrigeration Package' }
      };
      if (pkg && PACKAGES[pkg]) {
        const p = PACKAGES[pkg];
        return {
          ref,
          pill: 'Used Package',
          heading: 'Your package details.',
          description: p.size + ' · ' + p.chiller + ' Chiller. Tell us your site location and we\'ll get back to you with availability and delivery details.',
          submitLabel: 'Send Inquiry',
          message: 'Used Equipment — Package ' + pkg + ', ' + p.size + ', ' + p.chiller + ' Chiller',
          emailFull: 'Used Equipment — Package ' + pkg + ', ' + p.size + ', ' + p.chiller + ' Chiller'
        };
      }
      return {
        ref,
        pill: 'Used Equipment',
        heading: 'Used Equipment Inquiry',
        description: 'Tell us which package number you\'re interested in and your site location.',
        submitLabel: 'Send Inquiry',
        message: 'Used Equipment Inquiry',
        emailFull: 'Used Equipment Inquiry'
      };
    }

    const SIMPLE_REFS = {
      'off-season-storage': {
        pill: 'Off-Season Storage',
        heading: 'Reserve your storage spot.',
        description: 'Tell us a bit about your equipment and site location, and we\'ll get back to you with availability and details.',
        submitLabel: 'Request Storage',
        title: 'Off-Season Storage Inquiry'
      },
      'ice-maintenance': {
        pill: 'Ice Maintenance',
        heading: 'Request a maintenance quote.',
        description: 'Tell us about your rink and what you need serviced — we\'ll follow up with a quote and scheduling.',
        submitLabel: 'Request Quote',
        title: 'Ice Maintenance Quote Request'
      },
      'installation': {
        pill: 'Installation',
        heading: 'Get your install started.',
        description: 'Share your site details and timeline, and our crew will reach out to plan the installation.',
        submitLabel: 'Request Installation',
        title: 'Installation Inquiry'
      },
      'rink-closure': {
        pill: 'Rink Closure',
        heading: 'Schedule your rink closure.',
        description: 'Tell us about your rink and when you need it closed down for the season — we\'ll handle the rest.',
        submitLabel: 'Request Closure',
        title: 'Rink Closure Service Inquiry'
      },
      'portable-refrigeration': {
        pill: 'Portable Refrigeration',
        heading: 'Get a refrigeration quote.',
        description: 'Tell us your rink size and site location, and we\'ll get back to you with a portable refrigeration quote.',
        submitLabel: 'Request Quote',
        title: 'Portable Refrigeration Quote Request'
      },
      'refrigeration-packages': {
        pill: 'Refrigeration Package',
        heading: 'Get a package quote.',
        description: 'Tell us your rink size and site location, and we\'ll recommend the right refrigeration package and send a quote.',
        submitLabel: 'Request Quote',
        title: 'Refrigeration Package Quote Request'
      },
      'event-rentals': {
        pill: 'Event Rental',
        heading: 'Plan your event rink.',
        description: 'Share your event date, venue, and goals, and we\'ll put together a custom rental plan.',
        submitLabel: 'Request Quote',
        title: 'Special Event Rental Inquiry'
      },
      'projects': {
        pill: 'New Project',
        heading: 'Start your project.',
        description: 'Tell us what you\'re planning and we\'ll get the right people involved to scope it out.',
        submitLabel: 'Start Project',
        title: 'New Project Inquiry'
      },
      'rinks': {
        pill: 'Rink Consultation',
        heading: 'Consult an engineer.',
        description: 'Share your project details and our engineering team will reach out to discuss your rink.',
        submitLabel: 'Request Consultation',
        title: 'Rink Engineering Consultation'
      },
      'pool-to-rink': {
        pill: 'Pool-to-Rink',
        heading: 'Start your pool review.',
        description: 'Tell us about your pool and site, and we\'ll start a feasibility review for a winter rink conversion.',
        submitLabel: 'Start Pool Review',
        title: 'Pool-to-Rink Conversion Inquiry'
      },
      'indoor-rinks': {
        pill: 'Indoor Rink',
        heading: 'Consult with an engineer.',
        description: 'Tell us about your building and what you\'re planning, and our engineering team will reach out.',
        submitLabel: 'Request Consultation',
        title: 'Indoor Rink Inquiry'
      }
    };
    if (SIMPLE_REFS[ref]) {
      const r = SIMPLE_REFS[ref];
      const heading = r.title.toUpperCase();
      const rule = '-'.repeat(heading.length);
      return {
        ref,
        pill: r.pill,
        heading: r.heading,
        description: r.description,
        submitLabel: r.submitLabel,
        message: heading + '\n' + rule + '\n\nAdditional notes:\n',
        emailFull: r.title
      };
    }

    if (ref === 'customizer') {
      const sizeDisplay = { starter: "20' x 40'", club: "40' x 80'", custom: 'Custom size' };
      const formatLabels = { rental: 'Seasonal Rental', permanent: 'Permanent', portable: 'Portable' };
      const typeLabels = { outdoor: 'Outdoor', indoor: 'Indoor', synthetic: 'Synthetic Ice' };
      const outdoorBaseLabels = { pool: 'Pool-to-Rink', court: 'Court Conversion', standard: '' };
      const accs = Array.isArray(d.accessories) ? d.accessories : [];
      const accNames = accs.map(function(a){ return this.ACC_LABELS[a] || a; }, this).filter(Boolean);
      const sizeStr = sizeDisplay[d.size] || d.size || '';
      const typeStr = typeLabels[d.type] || d.type || '';
      const baseStr = (d.type === 'outdoor' && d.outdoorBase && d.outdoorBase !== 'standard') ? outdoorBaseLabels[d.outdoorBase] || '' : '';
      const formatStr = formatLabels[d.format] || d.format || '';
      const typeDetail = baseStr ? typeStr + ' (' + baseStr + ')' : typeStr;
      const extras = [];
      if (d.branding) extras.push('Custom Logo');
      if (d.maintenance && d.maintenance !== 'none') extras.push('Maintenance');
      const summaryParts = [sizeStr, typeDetail, formatStr].filter(Boolean);
      const allExtras = accNames.concat(extras);
      const emailFull = 'Rink Customizer — ' + summaryParts.join(', ') +
        (allExtras.length ? ' · ' + allExtras.join(', ') : '');
      return {
        ref,
        pill: 'Rink Builder',
        heading: 'Your rink config is ready.',
        description: summaryParts.join(' · ') + (allExtras.length ? ' · ' + allExtras.join(', ') : ''),
        submitLabel: 'Send Config + Request Quote',
        message: 'RINK CUSTOMIZER DETAILS\n-----------------------\n' + emailFull + '\n\nAdditional notes:\n',
        emailFull
      };
    }
    return null;
  },

  init() {
    this.payload = this.read();
    if (!this.payload) return;
    this.render();
    this.prefill();
  },

  render() {
    const el = document.getElementById('contact-ctx-indicator');
    if (!el || !this.payload) return;
    el.classList.remove('hidden');
    const pill = el.querySelector('.ctx-pill');
    if (pill) pill.textContent = this.payload.pill;

    const form = document.getElementById('standard-contact-form');
    if (form) {
      const h3 = form.querySelector('h3');
      const desc = form.querySelector('p');
      const submit = form.querySelector('.stepper-submit');
      if (h3) h3.textContent = this.payload.heading;
      if (desc) desc.textContent = this.payload.description;
      if (submit) submit.textContent = this.payload.submitLabel;
    }
  },

  prefill() {
    if (!this.payload) return;
    const ta = document.querySelector('.standard-val[data-key="generalMessage"]');
    if (ta && !ta.value) {
      ta.value = this.payload.message;
      ta.dispatchEvent(new Event('input'));
    }
  }
};

window.stepper = {
  current: 1,
  total: 7,
  mode: null,
  data: {},
  leadDefault: 'Whether you\u2019re planning a rink or checking in with our team, we\u2019ll point your message where it needs to go.',
  leadRink: 'Share a few details about the rink, site, system, and timeline so the right team can follow up.',
  leadQuestion: 'Send a quick note for service, support, scheduling, storage, or general questions.',

  init() {
    this.bindEvents();
    this.updateDOM();
    window.addEventListener('resize', () => this.updateDOM());
    window.addEventListener('load', () => this.setViewportHeight());
  },

  chooseMode(mode, e) {
    if (e) e.stopPropagation();
    this.mode = mode;
    this.data.intent = mode === 'rink' ? 'Interested in a rink' : 'General question';
    this.data.submitMode = mode === 'rink' ? 'rink' : 'question';
    this.current = mode === 'rink' ? 2 : 1;
    this.updateDOM();
  },

  bindEvents() {
    document.querySelectorAll('.options-group .opt-btn').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const group = btn.closest('.options-group');
        const key = group.dataset.key;
        const val = btn.dataset.val;
        if (!key) return;

        // Multi-select groups toggle and wait for the Continue button.
        if (group.hasAttribute('data-multi')) {
          btn.classList.toggle('selected');
          this.data[key] = [...group.querySelectorAll('.opt-btn.selected')].map((b) => b.dataset.val);
          return;
        }

        group.querySelectorAll('.opt-btn').forEach((b) => b.classList.remove('selected'));
        btn.classList.add('selected');

        this.data[key] = val;
        setTimeout(() => this.next(), 200);
      });
    });

    document.querySelectorAll('.input-val').forEach((input) => {
      const syncInputValue = (e) => {
        const key = e.target.dataset.key;
        this.data[key] = e.target.value.trim();
        if (e.target.tagName === 'SELECT' && this.data[key] && !e.target.classList.contains('standard-val')) {
          setTimeout(() => this.next(), 200);
        }
      };
      input.addEventListener('input', syncInputValue);
      input.addEventListener('change', syncInputValue);
      input.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' && e.target.tagName !== 'TEXTAREA' && !e.target.classList.contains('standard-val')) {
          this.next();
        }
      });
    });

    document.querySelectorAll('.contact-stepper-shopify-form').forEach((shopifyForm) => {
      shopifyForm.addEventListener('submit', (e) => {
        if (this.mode === 'question') {
          if (!this.prepareGeneralSubmit(e, { keepEvent: true })) e.preventDefault();
        } else {
          e.preventDefault();
          this.next();
        }
      });
    });
  },

  isValid(step) {
    switch (step) {
      case 1: return !!this.mode;
      case 2: return !!this.data.rinkType;
      case 3: return !!this.data.size;
      case 4: return !!this.data.systemType;
      case 5: return !!this.data.surface;
      case 6: return true;
      case 7: return !!this.data.province;
      default: return false;
    }
  },

  back() {
    if (this.current <= 2) {
      // Go back to mode selection (step 1)
      this.mode = null;
      this.current = 1;
      this.data.intent = '';
    } else {
      if (this.current === this.total) this.clearProvince();
      this.current--;
    }
    const err = document.getElementById('stepper-error');
    if (err) err.classList.add('hidden');
    this.updateDOM();
  },

  next() {
    if (!this.isValid(this.current)) {
      const err = document.getElementById('stepper-error');
      err.textContent = 'Please make a selection to continue.';
      err.classList.remove('hidden');
      this.setViewportHeight();
      return;
    }
    document.getElementById('stepper-error').classList.add('hidden');

    if (this.current < this.total) {
      this.current++;
      this.updateDOM();
    } else {
      this.submit();
    }
  },

  setViewportHeight() {
    const track = document.getElementById('stepper-track');
    const viewport = track && track.parentElement;
    if (!track || !viewport || this.mode === 'question') return;

    const targetSlide = track.querySelector(`.stepper-slide[data-step="${this.current}"]`);
    if (!targetSlide) return;

    requestAnimationFrame(() => {
      viewport.style.height = targetSlide.scrollHeight + 'px';
    });
  },

  updateDOM() {
    const questionForm = document.getElementById('standard-contact-form');
    const progress = document.getElementById('progress-bars');
    const lead = document.getElementById('contact-lead');
    const backBtn = document.getElementById('stepper-back-btn');

    if (questionForm) questionForm.classList.toggle('hidden', this.mode !== 'question');
    if (progress) progress.classList.toggle('hidden', this.mode === 'question');
    if (lead) lead.textContent = this.mode === 'rink' ? this.leadRink : this.mode === 'question' ? this.leadQuestion : this.leadDefault;

    // Show back button on any step beyond step 1, or when mode is set
    if (backBtn) backBtn.classList.toggle('hidden', !this.mode || this.mode === 'question');

    // Un-hide the slide panel first so slides are measurable, then slide the
    // track and animate the viewport height to match the active slide.
    const slidePanel = document.getElementById('stepper-slide-panel');
    if (slidePanel) slidePanel.classList.toggle('hidden', this.mode === 'question');

    const track = document.getElementById('stepper-track');
    const viewport = track && track.parentElement;
    if (track && viewport && this.mode !== 'question') {
      const stepIndex = this.current - 1;
      const slides = track.querySelectorAll('.stepper-slide');
      const targetSlide = slides[stepIndex];
      if (targetSlide) {
        track.style.transform = `translateX(${-stepIndex * 100}%)`;
        this.setViewportHeight();
      } else {
        track.style.transform = `translateX(${-stepIndex * 100}%)`;
      }
    }

    document.querySelectorAll('.progress-bar-segment').forEach((bar) => {
      const index = parseInt(bar.dataset.index, 10);
      bar.classList.toggle('active', index <= this.current);
    });

  },

  // Fill Shopify's real contact form fields, then let the user's native form
  // submit continue so Shopify's spam/CAPTCHA flow can run normally.
  fillShopifyForm(fields, sentMode) {
    try { sessionStorage.setItem('ci_contact_sent', sentMode); } catch (e) {}
    const shopifyForm = document.getElementById('ContactStepperShopifyForm');
    if (shopifyForm) {
      const fixedFields = {
        name: shopifyForm.querySelector('[name="contact[name]"]'),
        email: shopifyForm.querySelector('[name="contact[email]"]'),
        phone: shopifyForm.querySelector('[name="contact[phone]"]'),
        body: shopifyForm.querySelector('[name="contact[body]"]'),
      };
      Object.keys(fixedFields).forEach((key) => {
        if (fixedFields[key]) fixedFields[key].value = fields[key] || '';
      });
      shopifyForm.querySelectorAll('[data-stepper-extra]').forEach((node) => node.remove());
      Object.entries(fields).forEach(([key, value]) => {
        if (!value || fixedFields[key]) return;
      });
      return true;
    }

    return false;
  },

  showError(message) {
    const err = this.mode === 'question'
      ? document.getElementById('general-form-error')
      : document.getElementById('stepper-error');
    if (err) {
      err.textContent = message;
      err.classList.remove('hidden');
    }
  },

  valueFor(key) {
    const el = document.querySelector(`.input-val[data-key="${key}"]`);
    return (el && typeof el.value === 'string' ? el.value.trim() : '') || this.data[key] || '';
  },

  accessoriesSummary() {
    const picked = Array.isArray(this.data.accessories) ? this.data.accessories.slice() : [];
    const other = this.valueFor('accessoriesOther');
    if (other) picked.push(other);
    return picked.join(', ');
  },

  buildRinkSummary() {
    const d = {
      intent: this.data.intent || 'Interested in a rink',
      rinkType: this.valueFor('rinkType'),
      size: this.valueFor('size'),
      systemType: this.valueFor('systemType'),
      surface: this.valueFor('surface'),
      accessories: this.accessoriesSummary(),
      province: this.valueFor('province'),
    };
    return (
      `RINK REQUEST DETAILS\n` +
      `--------------------\n` +
      `Intent: ${d.intent || ''}\n` +
      `Rink type: ${d.rinkType || ''}\n` +
      `Approx size: ${d.size || ''}\n` +
      `System type: ${d.systemType || ''}\n` +
      `Surface: ${d.surface || ''}\n` +
      `Add-ons: ${d.accessories || 'None'}\n` +
      `Province: ${d.province || ''}\n\n` +
      `Additional notes:\n`
    );
  },

  isValidPhone(value) {
    const phone = value || '';
    if (!/^[0-9+() .-]+$/.test(phone)) return false;
    const cleaned = phone.replace(/[^\d]/g, '');
    return cleaned.length >= 7;
  },

  submit() {
    this.prepareRinkSubmit();
  },

  prepareRinkSubmit(e, options = {}) {
    if (e && !options.keepEvent) e.stopPropagation();
    const d = {
      intent: this.data.intent || 'Interested in a rink',
      rinkType: this.valueFor('rinkType'),
      size: this.valueFor('size'),
      systemType: this.valueFor('systemType'),
      surface: this.valueFor('surface'),
      accessories: this.accessoriesSummary(),
      province: this.valueFor('province'),
    };
    const isReady = d.rinkType && d.size && d.systemType && d.surface && d.province;
    if (!isReady) {
      this.showError('Please make a selection to continue.');
      return false;
    }

    const summary = this.buildRinkSummary();

    this.mode = 'question';
    this.data.generalName = '';
    this.data.generalEmail = '';
    this.data.generalPhone = '';
    this.data.generalMessage = summary;
    this.data.submitMode = 'rink';
    this.updateDOM();

    const generalForm = document.getElementById('standard-contact-form');
    if (generalForm) {
      const h3 = generalForm.querySelector('h3');
      const desc = generalForm.querySelector('p');
      const submit = generalForm.querySelector('.stepper-submit');
      if (h3) h3.textContent = 'Send your rink request.';
      if (desc) desc.textContent = 'Your rink brief is ready. Add your contact details and send it to the team.';
      if (submit) submit.textContent = 'Submit Rink Request';
    }

    const set = (key, value) => {
      const el = document.querySelector(`.standard-val[data-key="${key}"]`);
      if (el) el.value = value || '';
    };
    set('generalName', '');
    set('generalEmail', '');
    set('generalPhone', '');
    set('generalMessage', summary);

    const contactSection = document.getElementById('contact');
    if (contactSection) {
      requestAnimationFrame(() => {
        const header = document.querySelector('header, .shopify-section-header-sticky, sticky-header');
        const headerHeight = header ? header.getBoundingClientRect().height : 0;
        const sectionTop = contactSection.getBoundingClientRect().top + window.pageYOffset;
        window.scrollTo({ top: Math.max(0, sectionTop - headerHeight), behavior: 'smooth' });
      });
    } else if (generalForm) {
      generalForm.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    return false;
  },

  submitGeneral(e) {
    return this.prepareGeneralSubmit(e);
  },

  prepareGeneralSubmit(e, options = {}) {
    if (e && !options.keepEvent) e.stopPropagation();
    const general = {
      name: this.valueFor('generalName'),
      email: this.valueFor('generalEmail'),
      phone: this.valueFor('generalPhone'),
      message: this.valueFor('generalMessage'),
    };
    const isReady = general.name && general.email && general.message;
    if (!isReady) {
      this.showError('Please add your name, email, phone, and question before submitting.');
      return false;
    }
    if (!general.phone || !this.isValidPhone(general.phone)) {
      this.showError('Please add a valid phone number before submitting.');
      return false;
    }
    const err = document.getElementById('stepper-error');
    if (err) err.classList.add('hidden');
    const genErr = document.getElementById('general-form-error');
    if (genErr) genErr.classList.add('hidden');

    this.fillShopifyForm({
      name: general.name,
      email: general.email,
      phone: general.phone,
      body: general.message,
    }, this.data.submitMode || 'question');
    return true;
  },

  // After Shopify accepts the form it redirects back with ?contact_posted=true.
  showPostedSuccess() {
    let sentMode = 'question';
    try {
      sentMode = sessionStorage.getItem('ci_contact_sent') || 'question';
      sessionStorage.removeItem('ci_contact_sent');
    } catch (e) {}
    const wrapper = document.getElementById('stepper-wrapper');
    if (!wrapper) return;
    wrapper.innerHTML = sentMode === 'rink'
      ? `
      <div class="success-panel">
        <h3>Design Session Requested.</h3>
        <p>Thank you! Your rink details have been routed to our design crew. Expect an email with initial layouts within 24 hours.</p>
      </div>
    `
      : `
      <div class="success-panel">
        <h3>Question Sent.</h3>
        <p>Thank you! The Center Ice Rinks team will review your note and follow up shortly.</p>
      </div>
    `;
    const progBars = document.getElementById('progress-bars');
    if (progBars) progBars.style.opacity = '0.4';
    const section = document.getElementById('contact');
    if (section) {
      const header = document.querySelector('header, .shopify-section-header-sticky, sticky-header');
      const headerHeight = header ? header.getBoundingClientRect().height : 0;
      const sectionTop = section.getBoundingClientRect().top + window.pageYOffset;
      window.scrollTo({ top: Math.max(0, sectionTop - headerHeight), behavior: 'smooth' });
    }
  },

  resetMode(e) {
    if (e) e.stopPropagation();
    this.mode = null;
    this.current = 1;
    this.data.intent = '';
    this.data.submitMode = 'question';
    this.clearRinkAnswers();
    const err = document.getElementById('stepper-error');
    if (err) err.classList.add('hidden');
    this.updateDOM();
  },

  // Starting over clears every rink answer. The province select advances on
  // change, so a leftover value would leave no way to re-pick it.
  clearProvince() {
    delete this.data.province;
    const select = document.querySelector('.stepper-slide select.input-val[data-key="province"]');
    if (select) select.selectedIndex = 0;
  },

  clearRinkAnswers() {
    ['rinkType', 'size', 'systemType', 'surface', 'accessories', 'accessoriesOther', 'province'].forEach((key) => delete this.data[key]);
    document.querySelectorAll('.stepper-slide .opt-btn.selected').forEach((b) => b.classList.remove('selected'));
    document.querySelectorAll('.stepper-slide .input-val').forEach((input) => {
      if (input.tagName === 'SELECT') input.selectedIndex = 0;
      else input.value = '';
    });
  }
};

document.addEventListener('DOMContentLoaded', () => {
  if (document.getElementById('stepper-wrapper')) {
    window.stepper.init();
    if (new URLSearchParams(window.location.search).get('contact_posted') === 'true') {
      window.stepper.showPostedSuccess();
      return;
    }
    window.contactContext.init();
    if (window.contactContext.payload) {
      window.stepper.chooseMode('question', null);
    }
  }
});
